module.exports = __webpack_public_path__ + "static/media/houses-of-the-holy.0fe39772.jpg";